import axios from '../Axios/Default';
import { handleResponse } from './HelperService';

const registerUser = (payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/register/user`, payload);
    return handleResponse(response, onSuccess, onError);
};

const getUserIdentity = (payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/register/identity`, {email: payload});
    return handleResponse(response, onSuccess, onError);
};

export { registerUser, getUserIdentity };